require('./RAAccordionStep.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @components
const RAAccordion = require('../RAAccordion/RAAccordion');
const RAAccordionRow = require('../RAAccordion/RAAccordionRow/RAAccordionRow');
const OKModal = require('commonsComponents/OKModal');

class RAAccordionStep extends React.Component {
    buildModal() {
        const { contentModal } = this.props;
        if (contentModal) {
            const content = (
                <div className="robo-accordion-step__modal_content">
                    {contentModal.content}
                </div>
            );
            return (
                <OKModal
                    content={content}
                    footerType="action"
                    headerType="custom"
                    isOpen={contentModal.isOpen}
                    onCloseCallback={() => contentModal.closeModal()}
                    onPrimaryButtonClick={() => contentModal.closeModal()}
                    primaryButtonText={contentModal.buttonText}
                    shouldCloseOnOverlayClick={false}
                    title={contentModal.title}
                    titleAlignment="center"
                />
            );
        }
    }
    buildRows() {
        const { disabled, openedTogglerText, closedToggleText } = this.props;

        const rows = this.props.rows.map(r => {
            const selectedOption = this.props.immAnswers.get(r.id);
            return (
                <RAAccordionRow
                    key={r.id}
                    row={r}
                    expandedRowId={this.props.expandedRowId}
                    expandAccordionRow={this.props.expandAccordionRow}
                    selectAccordionButton={this.props.selectAccordionButton}
                    selectedOption={selectedOption}
                    disabled={disabled}
                    openedTogglerText={openedTogglerText}
                    closedToggleText={closedToggleText}
                />
            );
        });

        return rows;
    }

    render() {
        const modal = this.buildModal();
        const rows = this.buildRows();

        return (
            <section className="robo-accordion-step">
                {modal}
                <div className="robo-accordion-step__header">
                    <span className="robo-accordion-step__title">
                        {this.props.title} {this.props.titleTooltip}
                    </span>{' '}
                    <div className="robo-accordion-step__subtitle">
                        {this.props.subtitle}
                    </div>
                </div>
                <RAAccordion>{rows}</RAAccordion>
            </section>
        );
    }
}

RAAccordionStep.propTypes = {
    disabled: PropTypes.bool,
    expandAccordionRow: PropTypes.func.isRequired,
    expandedRowId: PropTypes.string,
    immAnswers: PropTypes.object.isRequired,
    rows: PropTypes.array.isRequired,
    selectAccordionButton: PropTypes.func.isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    titleTooltip: PropTypes.any,
    closedToggleText: PropTypes.string,
    openedTogglerText: PropTypes.string,
    contentModal: PropTypes.object,
};

module.exports = RAAccordionStep;
